import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class Benefit extends React.Component {
  render () {
    return (
      <div className="feature">
        <div className={`big-icon text-${this.props.color} text-center`}>
          <FontAwesomeIcon icon={this.props.icon} />
        </div>
        <h5 className={`text-${this.props.color} text-center`}>{this.props.title}</h5>
        <p className="text-center">{this.props.text}</p>
      </div>
    );
  }
};

Benefit.propType = {
  color: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string
};

Benefit.defaultProps = {
  color: "primary",
  icon: "tools",
  title: "Work with Bootstrap",
  text: "Bootstrap 4 is a toolkit of front-end components for websites. It provides multiple utilities and components for writing responsive websites."
};

export default Benefit;
